import React from "react";
import Marquee from "react-fast-marquee";
import { Star } from "./Scribbles";

const WORDS = [
  "Creative Thinker",
  "Digital Artist",
  "Problem Solver",
  "Storyteller",
];

export const EditorialMarquee = ({ speed = 22 }) => {
  return (
    <div className="border-y-2 border-ink py-6 bg-sand-deep overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={speed} gradient={false} autoFill>
        {WORDS.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-word text-5xl md:text-7xl font-light text-ink px-8">
              {word}
            </span>
            <Star size={34} className="opacity-80" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
